<div class="or-dropdown or-floors-menu" [ngClass]="{ 'or-active': (isActive() | async) }">
  <button  [matMenuTriggerFor]="menu" data-cy="session-menu-drop-down-button" class="or-button or-rounded or-dropdown-trigger or-dropdown-trigger-inverse"
           (click)="toggle()" (menuClosed)='setActive(false)' (menuOpened)="userService.retrieveCurrentUser()">
    <span class="or-button-thumbnail"
          [ngStyle]="producePictureUrlStyle(user$ | async)"
          [ngClass]="{ 'or-icon-userpic': produceUserClass(user$ | async), 'or-inverse': !(this.isActive$ | async) }">
    </span>
    <span class="or-button-label" data-cy="current-user-label" [textContent]="(this.user$ | async)?.name"></span>
    @if (getIsTenant() | async) {
      <span matTooltip="You are part of a Tenant in the current Building" class="ml-2 or-icon or-tiny or-icon-tenant" [ngClass]="{ 'or-inverse': !(this.isActive$ | async) }" data-cy="current-user-tenant-icon" data-test="current-user-tenant-icon"></span>
    }
  </button>
</div>

<mat-menu #menu="matMenu" class='mt-2'>
  <div class="min-w-[200px]">
    <span [appIsAuthorized]="GlobalAuthority.GLOBAL_ADMIN">
     <a data-cy='global-admin-menu-item' class="px-4 py-2" mat-menu-item [routerLink]="globalAdministrationBaseUrl">
        <mat-icon class='opacity-80'>badge</mat-icon>
        <span class="or-button-label ">Global Admin</span>
    </a>
    </span>
  <span [isFeatureAvailable]="'managingCompanyAdmin'" [appIsAuthorizedForManagingCompany]="[ManagingCompanyAuthorityType.MANAGING_COMPANY_ADMIN,    ManagingCompanyAuthorityType.MANAGE_GLOBAL_AUTHORITY_REQUEST]">
  <a data-cy='managing-company-admin-menu-item' class="px-4 py-2" mat-menu-item [routerLink]="getManagingCompanyAdminUrl(user$ | async)">
    <mat-icon class='opacity-80'>badge</mat-icon>
    <span class="or-button-label ">Company Management</span>
  </a>
</span>
    <a data-cy='user-info-menu-item' class="px-4 py-2" mat-menu-item [routerLink]="userInfoBaseUrl">
        <mat-icon class='opacity-80'>person</mat-icon>
        <span class="or-button-label">User Info</span>
    </a>
    <button data-cy='logout-menu-item' class="px-4 py-2" mat-menu-item (click)="logout()">
      <mat-icon class='opacity-80'>logout</mat-icon>
      Log out
    </button>
  </div>
</mat-menu>
